export default __webpack_public_path__ + "static/media/worker7.88cfa3cd.jpg";